import { LocalStorageKeys } from "@/core/@types/types";
import { exportarBlob } from "@/core/common/utils";
import { financasApiBaseUrl } from "@/core/services/protocols";
import { ensureSessionToken } from "@/core/services/middleware/SessionAuthentication";

const assertRelativeApiPath = (path: string) => {
  if (/^(https?:)?\/\//i.test(path)) {
    throw new Error("exportarBlobFinancasApi aceita apenas paths relativos");
  }
};

const buildFinancasApiUrl = (path: string) => {
  assertRelativeApiPath(path);

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (import.meta.env.DEV) return `/api${normalizedPath}`;

  return `${financasApiBaseUrl}${normalizedPath}`;
};

export default function useExportarBlobFinancasApi() {
  const exportarBlobFinancasApi = async (
    path: string,
    fetchInit: RequestInit = {}
  ) => {
    const url = buildFinancasApiUrl(path);
    const token = await ensureSessionToken(localStorage.getItem(LocalStorageKeys.TokenNewHorizons), fetchInit.method || "GET", url);
    const headers = new Headers(fetchInit.headers);

    headers.set("Authorization", `Bearer ${token}`);

    const downloaded = await exportarBlob(url, {
      ...fetchInit,
      credentials: "include",
      headers
    }, true);
    if (!downloaded) throw new Error("Não foi possível baixar o arquivo.");
  };

  return {
    exportarBlobFinancasApi
  };
}
